import React from "react";
// import { Link } from 'react-router-dom'
import classes from "./GoBackLink.module.scss";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const GoBackLink = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  return (
    <div className={`${classes.container} ${classes.link}`}>
      {" "}
      <Link href="#" onClick={goBack}>
        Go Back
      </Link>
    </div>
  );
};

export default GoBackLink;
